import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { updateExpandedHotelDetailScreen } from "../../../reducer/appHeaderReducer";
import { getInitials } from "../../../utils/helper";
import Apartments from "../../../assets/images/pngs/apartments.png";
import { useNavigate } from "react-router-dom";
import useResetState from "../../../hooks/useResetState";

const Heading = () => {
  const { hotelDetails, isAllHotelsSelected } = useSelector(
    (store) => store.login
  );
  const { resetState } = useResetState();

  const dispatch = useDispatch();
  const hotelInitials = getInitials(hotelDetails?.name);

  const navigate = useNavigate();

  const handleLogOut = () => {
    resetState();
    window.localStorage.clear("hotelId");
    window.localStorage.clear("token");
    navigate("/");
  };

  return (
    <div
      className="bg-[#FFF]  top-[0rem]  fixed w-[100vw]  px-5 z-[100] flex justify-between items-center
      border-b-[1px] border-[#EEEEEE]  py-3  "
    >
      {isAllHotelsSelected ? (
        <div
          className=" flex gap-2 p-2 py justify-center items-center rounded-[40px]"
          onClick={(e) => {
            dispatch(updateExpandedHotelDetailScreen(true));
          }}
        >
          <div>
            <div className="w-[24px] h-[24px] rounded-full overflow-hidden">
              <img
                src={Apartments}
                alt=""
                className="w-full h-full object-cover"
              />
            </div>
          </div>
          <div className="font-outfit font-[400] text-[12px] leading-[18px] text-[#000] whitespace-nowrap relative">
            All Properties
          </div>
        </div>
      ) : (
        <div
          className=" flex gap-2 p-2 py justify-center items-center rounded-[40px]"
          onClick={(e) => {
            dispatch(updateExpandedHotelDetailScreen(true));
          }}
        >
          <div>
            {Boolean(hotelDetails?.logo) ? (
              <div className="w-[24px] h-[24px] rounded-full overflow-hidden">
                <img
                  src={hotelDetails?.logo}
                  alt=""
                  className="w-full h-full object-cover"
                />
              </div>
            ) : (
              <>
                {" "}
                <button
                  className="w-[24px] h-[24px] rounded-full whitespace-nowrap
                     font-outfit     border border-black text-black  text-[12px] font-semibold uppercase"
                >
                  {hotelInitials}
                </button>
              </>
            )}
          </div>
          <div className="font-outfit font-[400] text-[12px] leading-[18px] text-[#000] whitespace-nowrap relative">
            {Boolean(hotelDetails?.name)
              ? hotelDetails?.name?.substring(0, 15)
              : "Hotel"}
          </div>
        </div>
      )}

      <div
        className="mx-2 bg-[#FFF] rounded-[16px]  flex gap-2 justify-start items-center p-2"
        onClick={handleLogOut}
      >
        <div className="font-outfit font-[500] text-[14px] leading-[21px] text-[#F36960]">
          {" "}
          Log Out
        </div>
      </div>
    </div>
  );
};

export default Heading;
